import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import pt from "./locales/pt.json";
import en from "./locales/en.json";
import de from "./locales/de.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pt: { translation: pt },
      en: { translation: en },
      de: { translation: de },
    },
    lng: "de",
    fallbackLng: "de",
    supportedLngs: ["pt", "en", "de"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["path", "localStorage"],
      caches: ["localStorage"],
      lookupLocalStorage: "kosmedico_lang",
      lookupFromPathIndex: 0,
    },
  });

export default i18n;
